import { jsx as _jsx } from "react/jsx-runtime";
import { EfficientListLoader } from "@faire/retailer-visitor-shared/components/EfficientListLoader/EfficientListLoader";
import { withFallback } from "@faire/retailer-visitor-shared/components/GhostLoading/helpers";
import { SaveToBoardProvider } from "@faire/retailer-visitor-shared/features/RetailerBoards/Context";
import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { Tile } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/MainContent/__internal__/ProductOrBrandGrid/__internal__/ProductFirst/__internal__/MarketplaceProductList/__internal__/Tile";
import { moveProductToFrontOfArray } from "@faire/retailer-visitor-shared/views/product/utils/moveProductToFrontOfArray";
import { withQueryParams } from "@faire/web--source/common/query-params/withQueryParams";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { trackCategoriesProductBatchView } from "@faire/web-api--source/events/categories/view/productBatch";
import { trackRetailerOnboardingCategoryPageHighlightedProductView } from "@faire/web-api--source/events/retailerOnboarding/view/categoryPageHighlightedProduct";
import isChromatic from "chromatic/isChromatic";
import { observer } from "mobx-react";
import * as React from "react";
import { withRouter } from "react-router-dom";
import styled, { css } from "styled-components";
var MarketplaceProductListBase = function(param) {
    var category = param.category, filterKeys = param.filterKeys, isLoading = param.isLoading, items = param.items, pageType = param.pageType, queryParams = param.queryParams, requestId = param.requestId, scrollRef = param.scrollRef, showVerticalImagery = param.showVerticalImagery, title = param.title, isScrollingToTop = param.isScrollingToTop, onFirstBatchVisible = param.onFirstBatchVisible, overrideItemsPerRow = param.itemsPerRow;
    var isSSR = useIsSSR();
    var renderTile = function(tileData) {
        return /*#__PURE__*/ _jsx(Tile, {
            tileData: tileData,
            product: tileData === null || tileData === void 0 ? void 0 : tileData.product,
            title: title,
            pageType: pageType,
            filterKeys: filterKeys,
            category: category,
            showVerticalImagery: showVerticalImagery
        });
    };
    var renderProductTileBatchPlaceholder = function(placeholderItems, tileBatchIndex) {
        return /*#__PURE__*/ _jsx(React.Fragment, {
            children: placeholderItems === null || placeholderItems === void 0 ? void 0 : placeholderItems.map(function(_, index) {
                return /*#__PURE__*/ _jsx(React.Fragment, {
                    children: renderTile(undefined)
                }, "placeholder-".concat(index));
            })
        }, "placeholder-batch-".concat(tileBatchIndex));
    };
    var onProductBatchVisible = function(items, tileBatchIndex) {
        if (tileBatchIndex === 0) {
            onFirstBatchVisible === null || onFirstBatchVisible === void 0 ? void 0 : onFirstBatchVisible();
        }
        if (requestId) {
            trackCategoriesProductBatchView(requestId, items.map(function(i) {
                var _i_product;
                return i === null || i === void 0 ? void 0 : (_i_product = i.product) === null || _i_product === void 0 ? void 0 : _i_product.token;
            }).filter(isNotUndefined).join(" "));
        }
    };
    var itemsPerRow = useResponsiveValue(overrideItemsPerRow !== null && overrideItemsPerRow !== void 0 ? overrideItemsPerRow : {
        mobileAndAbove: 2,
        tabletAndAbove: 4
    });
    var products = items.length > 0 ? items : withFallback(items, 20);
    //only highlight product if it is first page (no page query param)
    var displayProducts = queryParams.get("page") ? products : moveProductToFrontOfArray(products, queryParams.get("refP"), trackRetailerOnboardingCategoryPageHighlightedProductView);
    var testIdAttribute = isLoading ? "marketplace-product-list-loading" : "marketplace-product-list";
    return /*#__PURE__*/ _jsx(Wrapper, {
        $enableSearchResultCleanup: isLoggedInRetailer(),
        "data-test-id": testIdAttribute,
        $columns: itemsPerRow,
        ref: scrollRef,
        children: /*#__PURE__*/ _jsx(SaveToBoardProvider, {
            value: {
                trackOrigin: "category-page"
            },
            children: /*#__PURE__*/ _jsx(EfficientListLoader, {
                hashKey: requestId,
                data: displayProducts,
                batchSize: itemsPerRow * 2,
                renderComponent: renderTile,
                // Remember to update the placeholder if the tile changes
                placeholderFn: renderProductTileBatchPlaceholder,
                forceRender: isSSR || isChromatic(),
                onBatchVisible: onProductBatchVisible,
                filterFakeTile: true,
                threshold: -400,
                renderPlaceholderForNonFirstBatch: isScrollingToTop
            })
        })
    });
};
export var MarketplaceProductList = withRouter(withQueryParams(observer(MarketplaceProductListBase)));
var Wrapper = styled.div.withConfig({
    componentId: "sc-4ee4f14c-0"
})([
    "display:grid;align-self:stretch;grid-template-columns:[start] repeat(",
    ",minmax(0,1fr)) [end];",
    "{margin:",
    ";}",
    ""
], function(props) {
    return props.$columns;
}, responsiveMediaQueries.tabletAndAbove, function(param) {
    var $enableSearchResultCleanup = param.$enableSearchResultCleanup;
    return $enableSearchResultCleanup ? undefined : "0 -8px";
}, function(param) {
    var $enableSearchResultCleanup = param.$enableSearchResultCleanup;
    return $enableSearchResultCleanup ? css([
        "column-gap:",
        ";row-gap:",
        ";padding-top:",
        ";"
    ], getSpacing("1x"), getSpacing("3x"), getSpacing("1x")) : "margin: 0 -4px";
});
